import { css } from 'styled-components';
import { getColor } from '../mixins/colors';

export default css`
  html {
    font-size: 62.5% !important; // 62.5% makes it easier to convert px to rem from design-files. 10px = 1rem, 16px = 1.6rem
  }

  body {
    font-family: ${(p) => p.theme.typography.fontFamily};
    font-size: 1.6rem; // Here we are reseting the font-size to default to 16px
    margin: 0;
    padding: 0;
    border: 0;
    vertical-align: baseline;
    line-height: 1;
    color: ${getColor('grey', 900)};
    background-color: ${getColor('grey', 100)};

    // Scrollbar should always be visible
    overflow-y: scroll;
    &.overlay {
      // Disable scrolling in body, but keep scroll bar visible, while overlay is visible
      position: fixed;
      inset: 0;
    }

    & * {
      box-sizing: border-box;
    }
  }

  html,
  div,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  del,
  dfn,
  em,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  var,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  hgroup,
  menu,
  nav,
  output,
  ruby,
  section,
  summary,
  time,
  mark,
  audio,
  video {
    margin: 0;
    padding: 0;
    border: 0;
    vertical-align: baseline;
  }

  /* HTML5 display-role reset for older browsers */
  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  menu,
  nav,
  section {
    display: block;
  }

  ul,
  ol {
    list-style: none;
  }

  blockquote,
  q {
    quotes: none;
  }

  blockquote:before,
  blockquote:after,
  q:before,
  q:after {
    content: '';
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  a {
    text-decoration: none;
    color: ${getColor('grey', 900)};
  }

  input,
  textarea {
    &:focus,
    &:active,
    &:focus-visible {
      outline: none;
    }
  }

  img {
    max-width: 100%;
    height: auto;
  }

  button,
  input[type='submit'],
  input[type='reset'] {
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
  }
`;
